import { RouteObject } from 'react-router-dom';
import { RoutesEnum } from '~/constants/enums';
import UserCards from '~myAccount/pages/UserCards';
import AddUserCard from '~myAccount/pages/UserCards/AddUserCard';

const routes: RouteObject[] = [
  {
    path: RoutesEnum.USER_CARDS,
    children: [
      { index: true, element: <UserCards /> },
      {
        path: RoutesEnum.USER_ADD_CARD,
        element: <AddUserCard />,
      },
    ],
  },
];

export default routes;
